import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

// Step 1 Component
function Step1({ formData, handleChange, nextStep }) {
  return (
    <div>
      <h2>Step 1: Personal Information</h2>
      <label>
        Name:
        <input
          type="text"
          className="form-control"
          value={formData.name}
          onChange={(e) => handleChange("name", e.target.value)}
        />
      </label>
      <button className="btn btn-primary mt-3" onClick={nextStep}>Next</button>
    </div>
  );
}

// Step 2 Component
function Step2({ formData, handleChange, nextStep, prevStep }) {
  return (
    <div>
      <h2>Step 2: Contact Information</h2>
      <label>
        Email:
        <input
          type="email"
          className="form-control"
          value={formData.email}
          onChange={(e) => handleChange("email", e.target.value)}
        />
      </label>
      <div className="mt-3">
        <button className="btn btn-secondary" onClick={prevStep}>Previous</button>
        <button className="btn btn-primary ml-2" onClick={nextStep}>Next</button>
      </div>
    </div>
  );
}

// Step 3 Component
function Step3({ formData, handleChange, prevStep, submitForm }) {
  return (
    <div>
      <h2>Step 3: Review and Submit</h2>
      <p><strong>Name:</strong> {formData.name}</p>
      <p><strong>Email:</strong> {formData.email}</p>
      <div className="mt-3">
        <button className="btn btn-secondary" onClick={prevStep}>Previous</button>
        <button className="btn btn-success ml-2" onClick={submitForm}>Submit</button>
      </div>
    </div>
  );
}

// MultiStepForm Component
function MultiStepForm() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });
  const [submittedData, setSubmittedData] = useState([]);

  const handleChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const submitForm = () => {
    // Save the submitted data to the submittedData array
    setSubmittedData([...submittedData, formData]);

    // Clear the form
    setFormData({
      name: "",
      email: "",
    });

    // Reset the step to the first step
    setStep(1);

    // Optionally show a success message
    alert("Form Submitted!");
  };

  const handleNewPreview = () => {
    // Reset the submitted data and form
    setSubmittedData([]);
    setFormData({
      name: "",
      email: "",
    });
    setStep(1);
  };

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-6">
          {/* Form Column */}
          {step === 1 && (
            <Step1 formData={formData} handleChange={handleChange} nextStep={nextStep} />
          )}
          {step === 2 && (
            <Step2 formData={formData} handleChange={handleChange} nextStep={nextStep} prevStep={prevStep} />
          )}
          {step === 3 && (
            <Step3 formData={formData} handleChange={handleChange} prevStep={prevStep} submitForm={submitForm} />
          )}
        </div>
        <div className="col-md-6">
          {/* Submitted Data Column */}
          {submittedData.length > 0 ? (
            <div>
              <h2>All Submitted Data:</h2>
              <ul className="list-group">
                {submittedData.map((data, index) => (
                  <li key={index} className="list-group-item">
                    <p><strong>Name:</strong> {data.name}</p>
                    <p><strong>Email:</strong> {data.email}</p>
                  </li>
                ))}
              </ul>
              <button className="btn btn-info mt-3" onClick={handleNewPreview}>
                New Preview
              </button>
            </div>
          ) : (
            <div>
                <p>No data submitted yet.</p>
              {/* <h2>Preview Your Submission</h2>
              <p><strong>Name:</strong> {formData.name}</p>
              <p><strong>Email:</strong> {formData.email}</p> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MultiStepForm;
